/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { registerIVSTech } from 'amazon-ivs-player';
import { ContainerPlayer } from './styles';

const VideoIvsPlayer = (props) => {
  const {
    streamUrl,
  } = props;
  const videoRef = useRef(null);

  useEffect(() => {
    registerIVSTech(videojs, {
      wasmWorker: `${process.env.PUBLIC_URL}/amazon-ivs-wasmworker.min.js`,
      wasmBinary: `${process.env.PUBLIC_URL}/amazon-ivs-wasmworker.min.wasm`,
    });

    const player = videojs(videoRef.current, {
      techOrder: ['AmazonIVS'],
      autoplay: true,
      controls: true,
      fill: true,
      fluid: false,
    }, () => {
      player.src(streamUrl);
    });

    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, []);

  return (
    <ContainerPlayer>
      <video
        ref={videoRef}
        className="video-js"
        controls
        autoPlay
        playsInline
      />
    </ContainerPlayer>
  );
};

VideoIvsPlayer.propTypes = {
  streamUrl: PropTypes.string.isRequired,
};
export default VideoIvsPlayer;
